export default __webpack_public_path__ + "static/media/Bangkok-BTS-MRT-Map-2021.56ad2c7b.png";